module.exports = "<p>\r\n  referral-progress works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/alliance/referral-progress/referral-progress.component.html
// module id = ./src/app/shared-components/alliance/referral-progress/referral-progress.component.html
// module chunks = main